import { Component, ViewChild, OnInit, ViewContainerRef } from '@angular/core';


import { ItineraryService } from '../../shared/itinerary.service';
import { Subscription } from 'rxjs';
import {  } from 'google-maps';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'usb-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;

  navItems: any;
  styledMapType: any;

  map: google.maps.Map;
  poly: google.maps.Polyline;
  path;
  city: any;
  markers = [];
  iconMarkers = [];
  beaches = [];
  overlay;
  lat: number;
  lng: number;
  zoom: number;
  latswBound: number;
  lngswBound: number;
  latneBound: number;
  lngneBound: number;
  styles: google.maps.MapTypeStyle;

  subscription: Subscription;

  constructor(private itineraryService: ItineraryService,
    private http: HttpClient,
    public vcr: ViewContainerRef,
    ) {
    this.lat = 38;
    this.lng = -94;
    this.zoom = 4;
    this.latswBound = 23.2;
    this.lngswBound = -120.5;
    this.latneBound = 53.8;
    this.lngneBound = -70.5;
    this.styles = {
      'stylers': [{ 'visibility': 'off' }]
    };

  }

  ngOnInit() {
    // this.initMap();
    // this.initPolyline();
    // this.addLayout();
    // this.subscription = this.itineraryService.getObjectMap().subscribe((data: Array<any>) => {
    //   this.searchAdress(data);
    // });
  }

  initMap() {

    const mapOptions = {
      center: new google.maps.LatLng(this.lat, this.lng),
      zoom: this.zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      backgroundColor: '#FFFFFF',
      disableDefaultUI: true,
      draggable: true,
      scaleControl: true,
      scrollwheel: true,
      styles: [this.styles],
      minZoom: 4,
      maxZoom: 11
    };

    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapOptions);

    this.http.get('/assets/map-styles.json').subscribe((success:any) => {
      this.styledMapType = new google.maps.StyledMapType(success);
      this.map.mapTypes.set('styled_map', this.styledMapType);
      this.map.setMapTypeId('styled_map');
    });
// imagenes guardadas en carpeta icons
    this.beaches = [
      // ['Estatua de la Libertad', 40.689916, -74.045133, 2, 'new-york-liberty.svg'],
      // ['Montgomery Rosa Parks', 32.3757629, -86.321339 , 3 , 'alabama-montgomery-rosa-parks.svg'],
      // ['Aleutian Island Whales', 54.017795, -164.614373 , 3 , 'alaska-aleutian-island-whales.svg'],
      // ['Fairbanks Northern Lights', 64.828348, -147.7390414 , 3 , 'alaska-fairbanks-aurora.svg'],
      // ['Fairbanks Denali National Park', 63.1500151, -152.1388447 , 3 , 'alaska-fairbanks-denali.svg'],
      // ['Phoenix City', 33.6050991, -112.4052328 , 3 , 'arizona-phoenix-city.svg'],
      // ['Phoenix Grand Canyon', 36.0911048, -113.4035543 , 3 , 'arizona-phoenix-gran-canyon.svg'],
      // ['Williams Polar Express', 35.2517247, -112.1932812 , 3 , 'arizona-williams-polar-express.svg'],
      // ['Tucson Nature', 32.1558328, -111.0238884 , 3 , 'arizona-tucson-nature.svg'],
      // ['Sedona Red Rock', 34.861475, -111.7852417 , 3 , 'arizona-sedona-red-rock.svg'],
      // ['Arkansas Hot Spring National Park', 34.5486876, -93.0615737 , 3 , 'arkansas-litle-rock-hot-sprint-national-park.svg'],
      // ['Arkansas Ozark Caverns', 36.0328661, -93.7685538 , 3 , 'arkansas-ozark-caverns.svg'],
      // ['Cossatot River Fishing', 33.7876176, -94.1735161 , 3 , 'arkansas-cossatot-river-fishing.svg'],
      // ['Arkansas Logan County Mountains', 35.1690696, -93.6587124 , 3 , 'arkansas-logan-county-mountains.svg'],
      // ['California Santa Cruz Nature', 37.0102263, -122.0523295 , 4 , 'california-santa-cruz-nature.svg'],
      // ['California San Diego Beach', 32.6107744, -117.1908897 , 3 , 'california-san-diego-beach.svg'],
      // ['California San Diego Culture', 32.7387084, -117.1774188 , 3 , 'california-san-diego-culture.svg'],
      // ['California Orange County Costa Mesa', 33.6612992, -117.9445041 , 3 , 'california-orange-county-costa-mesa.svg'],
      // ['California Los Angeles Hollywood', 34.0937458, -118.3614976 , 3 , 'california-los-angeles-hollywood.svg'],
      // ['California Naple Vineyards', 33.7550925, -118.1302678 , 3 , 'california-naple-vineyards.svg'],
      // ['California San Francisco Parks and bridges', 37.8199286, -122.4782551 , 3 , 'california-san-francisco-bridge.svg'],
      // ['California San Francisco Alcatraz', 37.8269775, -122.4251442 , 3 , 'california-san-francisco-alcatraz.svg'],
      // ['California Sequoia National Park', 36.4741178, -118.7546915 , 3 , 'california-sequoia-national-park.svg'],
      // ['California Yosemite National Park', 37.8529772, -119.83129 , 3 , 'california-yosemite-national-park.svg'],
      // ['Colorado Denver City', 39.7642548, -104.9951941 , 3 , 'colorado-denver-city.svg'],
      // ['Colorado Denver Adventure', 39.645817, -105.1468869 , 3 , 'colorado-denver-adventure.svg'],
      // ['Colorado Denver Ski', 39.6545992, -105.3631356 , 3 , 'colorado-denver-ski.svg'],
      // ['Colorado Spring Garden of the Gods', 38.8783578, -104.8719443 , 3 , 'colorado-colorado-spring-garden-of-the-gods.svg'],
      // ['Colorado Spring Rocky Mountain National Park ', 40.3506475, -105.8165615 , 3 , 'colorado-colorado-spring-rocky-mountain-mational.svg'],
      // ['Colorado Aspen Ski', 39.1919409, -106.8288769 , 3 , 'colorado-aspen-ski.svg'],
      // ['Colorado Vail Ski', 39.6334556, -106.3952793 , 3 , 'colorado-vail-ski.svg'],
      // ['Colorado Telluride Waterfalls', 37.9205302, -107.7787751 , 3 , 'colorado-telluride-waterfalls.svg'],
      // ['Colorado Winter Park Ski', 39.8906241, -105.8119094 , 3 , 'colorado-winter-park-ski.svg'],
      // ['Connecticut Hartford Adventure', 41.7925387, -72.7480655 , 3 , 'connecticut-hartford-adventure.svg'],
      // ['Wilmington History', 39.7298967, -75.5645038 , 3 , 'delaware-wilmington-history.svg'],
      // ['Wilmington Culture', 39.7589493, -75.5823065 , 3 , 'delaware-wilmington-culture.svg'],
      // ['Miami Beach', 25.7817724, -80.1879184 , 3 , 'florida-miami-beach.svg'],
      // ['Orlando Disney', 28.4202525, -81.5853616 , 3 , 'florida-orlando-disney.svg'],
      // ['Orlando Universal', 28.4691848, -81.4978443 , 3 , 'florida-orlando-universal.svg'],
      // ['Orlando Sea World', 28.4157174, -81.4586947 , 3 , 'florida-orlando-seaworld.svg'],
      // ['Ft Lauderdale Beach', 26.1410956, -80.2156074 , 3 , 'florida-fort-lauderdale-beach.svg'],
      // ['Naple Beach', 26.1449028, -81.8295594 , 3 , 'florida-naples-beach.svg'],
      // ['St. Petersburgo Beach', 27.7787517, -82.7248603 , 3 , 'florida-st-petersburgo-beach.svg'],
      // ['Los Cayos Beach', 24.6488165, -83.8690726 , 3 , 'florida-cayos-beach.svg'],
      // ['Los Cayos Isla Morada', 24.9296086, -80.7092919 , 3 , 'florida-cayos-islamorada.svg'],
      // ['Los Cayos Key West', 24.564638, -81.7981376 , 3 , 'florida-cayos-keywest.svg'],
      // ['San Agustin Culture', 29.8988209, -81.3374924 , 3 , 'florida-san-agustin-culture.svg'],
      // ['San Agustin Primer asentamiento de Españoles ', 29.8911826, -81.3277887 , 3 , 'florida-san-agustin-pioners.svg'],
      // ['Tampa Parques temáticos', 27.986387, -82.497206 , 3 , 'florida-tampa-theme-parks.svg'],
      // ['Tampa Bush Garden', 28.0372161, -82.4194901 , 3 , 'florida-tampa-roller-coaster.svg'],
      // ['Tampa Winter', 27.860790, -82.507978 , 3 , 'florida-tampa-winter.svg'],
      // ['Tampa Legoland', 27.9889361, -81.6910705 , 3 , 'florida-tampa-legoland.svg'],
      // ['Sorasota Culture', 27.350450, -82.502550 , 3 , 'florida-sarasota-culture.svg'],
      // ['Sorasota Siesta Key', 27.2755864, -82.5684736 , 3 , 'florida-sarasota-siesta-key.svg'],
      // ['Sorasota Beach', 27.315751, -82.583586 , 3 , 'florida-sarasota-beach.svg'],
      // ['West Palm Beach Beach', 26.714007, -80.033606 , 3 , 'florida-west-palm-beach-beach.svg'],
      // ['West Palm Beach Shopping', 26.725721, -80.086139 , 3 , 'florida-west-palm-beach-shoping.svg'],
      // ['West Palm Beach Luxury', 26.704835, -80.056672 , 3 , 'florida-west-palm-beach-luxury.svg'],
      // ['Tallahassee Capital de Flordida', 30.4670647, -84.3969411 , 3 , 'florida-tallahassee-capital.svg'],
      // ['Jacksonville Reserva Natural', 30.4628631, -81.5580995 , 3 , 'florida-jacksonville-nature.svg'],
      // ['Jacksonville Culture', 30.3565705, -81.7152237 , 3 , 'florida-jacksonville-culture.svg'],
      // ['Jacksonville Shopping', 30.2511203, -81.5423432 , 3 , 'florida-jacksonville-shoping.svg'],
      // ['Atlanta Culture', 33.7445348, -84.433861 , 3 , 'georgia-atlanta-culture.svg'],
      // ['Savannah History', 32.057277, -81.058663 , 3 , 'georgia-savannah-history.svg'],
      // ['Savannah Culture',  32.116299, -81.215518  , 3 , 'georgia-savannah-culture.svg'],
      // ['Waikiki Beach', 21.280632, -157.837100 , 3 , 'hawai-waikiki-beach.svg'],
      // ['Waikiki History', 21.288363, -157.834402 , 3 , 'hawai-waikiki-history.svg'],
      // ['Waikiki Hawai Volcanes National Park', 19.3833349, -155.2087593 , 3 , 'hawai-waikiki-volcano.svg'],
      // ['Lanai Beach', 20.740262, -156.895350  , 3 , 'hawai-lanai-beach.svg'],
      // ['Lanai Whales', 20.8713874, -156.6798474 , 3 , 'hawai-lanai-whales.svg'],
      // ['Oahu Beach', 21.3927064, -157.7177093 , 3 , 'hawai-oahu-beach.svg'],
      // ['Oahu Snorkel', 21.7006074, -157.9989853 , 3 , 'hawai-oahu-snorkel.svg'],
      // ['Kauai Beach', 22.205718, -159.499626 , 3 , 'hawai-kauai-beach.svg'],
      // ['Kauai Natural Pools', 22.2290867, -159.4882248 , 3 , 'hawai-kauai-natural-pools.svg'],
      // ['Lewiston Snake River', 46.4021941, -117.0468761 , 3 , 'idaho-lewiston-snake-river.svg'],
      // ['Lewiston Kayak', 46.419117, -117.0914937 , 3 , 'idaho-lewiston-kayak.svg'],
      // ['Idaho Pocatello', 42.8653304, -112.5873068 , 3 , 'idaho-pocatello.svg'],
      // ['Idaho Biking', 47.3684877, -116.7748827 , 3 , 'idaho-biking.svg'],
      // ['Stanley Adventure', 44.2138435, -114.9456436  , 3 , 'idaho-stanley-adventure.svg'],
      // ['Idaho Yellowstone', 44.5854032, -111.0744624 , 3 , 'idaho-yellowstone.svg'],
      // ['Chicago Culture', 41.970000, -87.730937 , 3 , 'illinois-chicago-culture.svg'],
      // ['Chicago Gastronomy', 41.727354, -87.659470  , 3 , 'illinois-chicago-gastronomy.svg'],
      // ['Chicago History', 41.965963, -87.886568 , 3 , 'illinois-chicago-history.svg'],
      // ['Rockford Cataratas', 42.322887, -88.9775746 , 3 , 'illinois-rockford-waterfalls.svg'],
      // ['Springfield History', 39.7795151, -89.6904067 , 3 , 'illinois-springfield-history.svg'],
      // ['Pontiac Route 66', 40.8793899, -88.6574634 , 3 , 'illinois-pontiac-route66.svg'],
      // ['Indianapolis', 39.7750067, -86.1891394 , 3 , 'indiana-indianapolis.svg'],
      // ['Fort Wyne Culture', 41.173486, -85.108060 , 3 , 'indiana-fort-wyne-culture.svg'],
      // ['Fort Wyne History', 41.0107768, -85.2419294 , 3 , 'indiana-fort-wyne-history.svg'],
      // ['Iowa City Culture', 41.6505712, -91.5927051 , 3 , 'iowa-iowa-city-culture.svg'],
      // ['Iowa City Gastronomy', 41.653710, -91.488032 , 3 , 'iowa-iowa-city-gastronomy.svg'],
      // ['Madison County Los puentes de Madison', 41.357739, -93.9414697 , 3 , 'iowa-madison-county-bridges.svg'],
      // ['Dubuque Adventures', 42.4980341, -90.7837039 , 3 , 'iowa-dubuque-adventure.svg'],
      // ['Dubuque Mountains', 42.4990642, -90.7841631 , 3 , 'iowa-dubuque-mountains.svg'],
      // ['Wichita Adventure', 37.717034, -97.4107497 , 3 , 'kansas-wichita-adventure.svg'],
      // ['Wichita History',  37.6834089, -97.4431309 , 3 , 'kansas-wichita-history.svg'],
      // ['Dodge City Cowboys', 37.7598364, -100.0343828 , 3 , 'kansas-dodge-city-cowboys.svg'],
      // ['Kansas City Culture', 39.1055168, -94.6601201  , 3 , 'kansas-kansas-city-culture.svg'],
      // ['Kansas City History', 39.1730627, -94.6899377 , 3 , 'kansas-kansas-city-history.svg'],
      // ['Kansas City Gastronomy', 39.1420592, -94.815082 , 3 , 'kansas-kansas-city-gastronomy.svg'],
      // ['Frankfort Culture', 38.2028482, -84.8863875 , 3 , 'kentucky-frankfort-culture.svg'],
      // ['Frankfort History', 38.1805628, -84.836208 , 3 , 'kentucky-frankfort-history.svg'],
      // ['Lousville Mohuammad Ali', 38.2497191, -85.7935582 , 3 , 'kentucky-lousville-muhammad-ali.svg'],
      // ['Lousville Mammoth National Park', 37.1953628, -86.2106352 , 3 , 'kentucky-lousville-mammoth.svg'],
      // ['Kentucky Cumberland Falls', 36.8384668, -84.3467656 , 3 , 'kentucky-lousville-cumberland-falls.svg'],
      // ['Kentucky Kayak', 38.3239098, -85.6918508 , 3 , 'kentucky-lousville-kayak.svg'],
      // ['Lexington Culture', 38.0426006, -84.5348512 , 3 , 'kentucky-lexington-culture.svg'],
      // ['Lexington Gastronomy', 38.155148, -84.5257961 , 3 , 'kentucky-lexington-gastronomy.svg'],
      // ['New Orleans History', 29.9867748, -90.0594861  , 3 , 'luisiana-new-orleans-history.svg'],
      // ['New Orleans Culture', 30.05102, -89.9673595 , 3 , 'luisiana-new-orleans-culture.svg'],
      // ['Maine Acadia National Park', 44.3193131, -68.371441 , 3 , 'maine-arcadia-national-park.svg'],
      // ['Bal Harbor Mountains', 44.3900772, -68.208432 , 3 , 'maine-bal-harbor-mountains.svg'],
      // ['Baltimore Culture', 39.2838913, -76.6478725  , 3 , 'maryland-baltimore-culture.svg'],
      // ['Baltimore History', 39.3288044, -76.6079481 , 3 , 'maryland-baltimore-history.svg'],
      // ['Oakland Ski', 39.4158906, -79.417845 , 3 , 'maryland-oakland-ski.svg'],
      // ['Ocean City Beach', 38.4421553, -75.0556729 , 3 , 'maryland-ocean-city-beach.svg'],
      // ['Ocean City City', 38.3302743, -75.091362 , 3 , 'maryland-ocean-city-city.svg'],
      // ['Boston History', 42.3549042, -71.0727511 , 3 , 'massachusetts-boston-history.svg'],
      // ['Boston Culture', 42.2721323, -71.1505316 , 3 , 'massachusetts-boston-culture.svg'],
      // ['Lexington History', 42.4475986, -71.2490431 , 3 , 'massachusetts-lexington-history.svg'],
      // ['Cape Cod Nature', 41.9682168, -70.0462535 , 3 , 'massachusetts-cape-cod-nature.svg'],
      // ['Cape Cod Mountains', 41.6310883, -70.5959732 , 3 , 'massachusetts-cape-cod-mountains.svg'],
      // ['Detroit history', 42.3638568, -83.0898126 , 3 , 'michigan-detroit-history.svg'],
      // ['Detroit Culture', 42.2546649, -83.1900691 , 3 , 'michigan-detroit-culture.svg'],
      // ['Mackinack Island History', 45.8682743, -84.6284073 , 3 , 'michigan-mackinack-island-history.svg'],
      // ['Mackinack Island Culture',  45.8502029, -84.6192895 , 3 , 'michigan-mackinack-island-culture.svg'],
      // ['Traverse City Nature', 44.7504164, -85.6351846 , 3 , 'michigan-traverse-city-nature.svg'],
      // ['Pictured Rock National ', 46.545368, -86.7771241 , 3 , 'michigan-picture-rock-national.svg'],
      // ['Grand Rapid Adventure', 42.9563371, -85.7301285 , 3 , 'michigan-grand-rapid-adventure.svg'],

      // ['Saint Paul Grandes Lagos', 45.3302055, -93.7622615 , 3 , 'minnesota-big-lake.svg'],
      // ['Bloomington Cultural', 44.8262515, -93.349491 , 3 , 'minnesota-bloomington-culture.svg'],
      // ['Minneapolis Cultural', 44.9748825, -93.2327581 , 3 , 'minnesota-minneapolis-culture.svg'],
      // ['Minneapolis Shopping', 45.0284004, -93.3137046 , 3 , 'minnesota-minneapolis-shoping.svg'],
      // ['Minneapolis Museos', 44.9464902, -93.2892285 , 3 , 'minnesota-minneapolis-museum.svg'],
      // ['Voyagueurs Kayak', 48.497685, -93.0666037 , 3 , 'minnesota-voyagueurs-national-park-kayak.svg'],
      // ['Jackson History', 32.3122061, -90.2278447 , 3 , 'mississippi-jackson-history.svg'],
      // ['Columbus History', 33.5196649, -88.4516466 , 3 , 'mississippi-columbus-history.svg'],
      // ['Columbus Culture',  33.4945248, -88.4194319 , 3 , 'mississippi-columbus-culture.svg'],
      // ['Kansas City Culture', 39.2532159, -94.6713915 , 3 , 'missouri-kansas-city-culture.svg'],
      // ['Kansas City History', 39.1257823, -94.645486 , 3 , 'missouri-kansas-city-history.svg'],
      // ['Kansas City Gastronomy', 39.2704215, -94.7067997 , 3 , 'missouri-kansas-city-gastronomy.svg'],
      // ['Carthage Route 66', 37.175736, -94.3154471 , 3 , 'missouri-carthage-route66.svg'],
      // ['Carthage Culture', 37.175736, -94.3154471 , 3 , 'missouri-carthage-city-culture.svg'],
      // ['Carthage Gastronomy', 37.1598123, -94.3466663 , 3 , 'missouri-carthage-gastronomy.svg'],
      // ['Helena Cowboys', 46.5931224, -112.0384659 , 3 , 'montana-helena-cowboys.svg'],
      // ['Billings Bighorn Canyon National', 45.2915833, -108.0347657 , 3 , 'montana-billings-bighorn-canyon-national.svg'],
      // ['Billings Indians', 45.790817, -108.5623289 , 3 , 'montana-billings-indians.svg'],
      // ['Billings Culture', 45.8148691, -108.49101 , 3 , 'montana-billings-culture.svg'],
      // ['Billings History', 45.7832138, -108.5282181 , 3 , 'montana-billings-history.svg'],
      // ['St Marys Glaciars', 48.7435531, -113.4315195 , 3 , 'montana-st-marys-glacier.svg'],
      // ['St Marys Mountains', 48.7595535, -113.4771409 , 3 , 'montana-st-marys-mountains.svg'],
      // ['Big Sky Mountains', 45.2857289, -111.4012076 , 3 , 'montana-big-sky-mountains.svg'],
      // ['Big Sky Rivers', 45.2681868, -111.3013118 , 3 , 'montana-big-sky-rivers.svg'],
      // ['Big Sky Rapids', 45.2471368, -111.2562353 , 3 , 'montana-big-sky-rapids.svg'],
      // ['Bozeman Mountains', 45.6921304, -111.1521195 , 3 , 'montana-bozeman-mountains.svg'],
      // ['Bozeman Bike', 45.692904, -111.0856329 , 3 , 'montana-bozeman-bike.svg'],
      // ['Bozeman Yellowstone National Park', 44.427963, -110.588455 , 3 , 'montana-yellowstone.svg'],
      // ['Lincoln History', 40.8099628, -96.6952781 , 3 , 'nebraska-lincoln-history.svg'],
      // ['Lincoln Culture', 40.8474696, -96.6840402 , 3 , 'nebraska-lincoln-culture.svg'],
      // ['Lincoln Gastronomy', 40.7845781, -96.710981 , 3 , 'nebraska-lincoln-gastronomy.svg'],
      // ['Omaha History', 41.2716008, -96.0240245  , 3 , 'nebraska-omaha-history.svg'],
      // ['Omaha Culture', 41.2725252, -96.1423246 , 3 , 'nebraska-omaha-culture.svg'],
      // ['Gering Scotts Bluff', 41.8355936, -103.7092652 , 3 , 'nebraska-gering-scotts-bluff-national-monument.svg'],
      // ['Bayard Chimney Rock National Historic Site', 41.7057731, -103.3508144 , 3 , 'nebraska-bayard-chimney-rock-national-historic-site.svg'],
      // ['Carson City Culture', 39.16394, -119.7721705 , 3 , 'nevada-carson-city-culture.svg'],
      // ['Carson City Mountains',  39.1828301, -119.8107408 , 3 , 'nevada-carson-city-mountains.svg'],
      // ['Carson City Ski', 39.254494, -119.918613 , 3 , 'nevada-carson-city-ski.svg'],
      // ['Carson City Fishing', 39.1549088, -119.9410252 , 3 , 'nevada-carson-city-fishing.svg'],
      // ['Las Vegas Casinos', 36.1536794, -115.1728269 , 3 , 'nevada-las-vegas-casino.svg'],
      // ['Las Vegas Night', 36.1746807, -115.2430905 , 3 , 'nevada-las-vegas-night.svg'],
      // ['Las Vegas Lake Mead National recreation Area', 36.0973319, -114.4250949 , 3 , 'nevada-las-vegas-lake-mead-national-recreation-Area.svg'],
      // ['Las Vegas Lake Tahoe', 39.072185, -120.1561912 , 3 , 'nevada-las-vegas-lake-tahoe.svg'],
      // ['Las Vegas Adventure', 35.5151706, -114.3568922 , 3 , 'nevada-las-vegas-adventure.svg'],
      // ['Las Vegas Ski', 36.3037018, -115.6796327 , 3 , 'nevada-las-vegas-ski.svg'],
      // ['Las Vegas Lakes', 36.0143384, -114.6396313 , 3 , 'nevada-las-vegas-lakes.svg'],
      // ['Portsmouth Withe Mountains', 44.1743798, -71.5067543  , 3 , 'new-hampshire-portsmouth-white-mountains.sv'],
      // ['Portsmouth Ski', 44.2593601, -71.2437103 , 3 , 'new-hampshire-portsmouth-ski.svg'],
      // ['Newark Culture', 40.7313432, -74.2170748 , 3 , 'new-jersey-newark-culture.svg'],
      // ['Santa Fe Culture', 35.6826126, -106.0530757 , 3 , 'new-mexico-santa-fe-culture.svg'],
      // ['Albuquerque History', 35.0826103, -106.8165626 , 3 , 'new-mexico-albuquerque-history.svg'],
      // ['Albuquerque Indians', 35.1643984, -106.8691587 , 3 , 'new-mexico-albuquerque-indians.svg'],
      // ['Albuquerque Balloons', 35.2137296, -106.6242187 , 3 , 'new-mexico-albuquerque-ballons.svg'],
      // ['Albuquerque Adventure', 35.118414, -106.5484828 , 3 , 'new-mexico-albuquerque-adventure.svg'],
      // ['Carldsbad Caverns', 32.140161, -104.5851484 , 3 , 'new-mexico-carldsbad-caverns.svg'],
      // ['New York theatres', 40.7616334, -73.9890464 , 3 , 'new-york-new-york-theater.svg'],
      // ['New York Culture', 40.7379191, -73.9990627 , 3 , 'new-york-culture.svg'],
      // ['New York Niagara Falls', 43.0995002, -79.0437609 , 3 , 'new-york-niagara-falls.svg'],
      // ['Syracusa History', 43.0352286, -76.1742994 , 3 , 'new-york-syracusa-history.svg'],
      // ['Finger Lakes Falls', 42.6639671, -77.2668452 , 3 , 'new-york-finger-lakes-waterfalls.svg'],
      // ['Finger Lakes Mountains', 42.3939286, -77.2624998 , 3 , 'new-york-finger-lakes-mountains.svg'],
      // ['The Catskills Mountains', 42.011078, -74.4210834 , 3 , 'new-york-the-catskills-mountains.svg'],
      // ['The Catskills Ski', 42.197265, -74.2254246 , 3 , 'new-york-the-catskills-ski.svg'],
      // ['Bismarck Indians', 6.8090546, -100.8370939 , 3 , 'north-dakota-bismark-indians.svg'],
      // ['Grand Forks Aurora', 47.9130682, -97.1434565 , 3 , 'north-dakota-grand-forks-aurora.svg'],
      // ['South Billings Theodore Roosvelt National Park', 46.9641726, -103.5514846 , 3 , 'north-dakota-south-billings-theodore-roosevelt-national-park.svg'],
      // ['Columbus Culture', 39.9828671, -83.1309116  , 3 , 'ohio-columbus-culture.svg'],
      // ['Columbus Zoo', 40.1714653, -83.0829757 , 3 , 'ohio-columbus-zoo.svg'],
      // ['Brecksville Cuyahoga National Park', 41.2829453, -81.5782524 , 3 , 'ohio-brecksville-cuyahoga-national-park.svg'],
      // ['Cleveland Culture', 41.4975108, -81.7758995 , 3 , 'ohio-cleveland-culture.svg'],
      // ['Oklahoma City Cowboys', 35.5356483, -97.4854355 , 3 , 'oklahoma-oklahoma-city-cowboys.svg'],
      // ['Oklahoma City Culture', 35.4711984, -97.5520392 , 3 , 'oklahoma-oklahoma-city-culture.svg'],
      // ['Oklahoma City Route 66', 35.5758851, -97.4472459 , 3 , 'oklahoma-oklahoma-city-route66.svg'],
      // ['Tulsa Culture', 36.1366371, -95.9762316 , 3 , 'oklahoma-tulsa-culture .svg'],
      // ['Tulsa Architecture', 36.0964, -95.7287868 , 3 , 'oklahoma-tulsa-local-architecture.svg'],
      // ['Portland Culture', 45.5140712, -122.6754872 , 3 , 'oregon-portland-culture.svg'],
      // ['Portland Gastronomy', 45.5070676, -122.6303033 , 3 , 'oregon-portland-gastronomy.svg'],
      // ['Portland History', 45.5429622, -122.6945615 , 3 , 'oregon-portland-history.svg'],
      // ['Crater Lake National Park', 42.9360139, -122.2756403 , 3 , 'oregon-crater-lake-national-park.svg'],
      // ['Eugene Mountains', 43.9234931, -122.3147442 , 3 , 'oregon-eugene-mountains.svg'],
      // ['Eugene Ski', 44.15246, -122.7257521 , 3 , 'oregon-eugene-ski.svg'],
      // ['Eugene Beach', 44.030105, -124.1514224 , 3 , 'oregon-eugene-beach.svg'],
      // ['Eugene Adventure', 44.0565558, -123.1693993 , 3 , 'oregon-eugene-adventure.svg'],
      // ['Willamette Valley Mountains', 44.9532734, -122.4471135 , 3 , 'oregon-willamette-valley-mountains.svg'],
      // ['Willamette Valley History', 44.7755786, -123.4260056 , 3 , 'oregon-willamette-valley-history.svg'],
      // ['Willamette Valley Wines', 44.8920507, -123.0883301 , 3 , 'oregon-willamette-valley-vineyards.svg'],
      // ['Mount Hood Sports', 45.3718767, -121.722365 , 3 , 'oregon-mount-hood-sports.svg'],
      // ['Mount Hood Ski', 45.3371036, -121.679953 , 3 , 'oregon-mount-hood-ski.svg'],
      // ['Mount Hood Balloons', 45.3932438, -122.1030062 , 3 , 'oregon-mount-hood-balloons.svg'],
      // ['Mount Hood Adventure', 45.3628669, -122.2880974 , 3 , 'oregon-mount-hood-adventure.svg'],
      // ['Philadelphia History', 39.9967869, -75.1972413  , 3 , 'pennsylvania-philadelphia-history.svg'],
      // ['Brandywine and Valley Forge History', 39.9093755, -74.9529936 , 3 , 'pennsylvania-brandywine-and-valley-forge.svg'],
      // ['Hershey and Harrisburg History', 40.2992996, -76.907691 , 3 , 'pennsylvania-hershey-and-harrisburg-history.svg'],
      // ['Hershey and Harrisburg Mountains', 41.2853947, -77.9646628 , 3 , 'pennsylvania-hershey-and-harrisburg-mountains.svg'],
      // ['Hershey and Harrisburg Theme Parks', 40.3442084, -76.805753 , 3 , 'pennsylvania-hershey-and-harrisburg-theme-parks.svg'],
      // ['Hershey and Harrisburg Chocolate', 40.3012461, -76.8281079 , 3 , 'pennsylvania-hershey-and-harrisburg-chocolate.svg'],
      // ['Hershey and Harrisburg Wines', 40.3062243, -76.7942828 , 3 , 'pennsylvania-hershey-and-harrisburg-vineyards.svg'],
      // ['Gettysburg History', 39.839566, -77.2276638 , 3 , 'pennsylvania-gettysburg-history.svg'],
      // ['Gettysburg Culture', 39.834894, -77.2474699, 3 , 'pennsylvania-gettysburg-culture.svg'],
      // ['Providence Gondolas', 41.8273089, -71.4136971 , 3 , 'rhode-island-providence-gondola.svg'],
      // ['Providence Beach', 41.8004145, -71.3938783 , 3 , 'rhode-island-providence-beach.svg'],
      // ['Providence Culture', 41.8343358, -71.4318188 , 3 , 'rhode-island-providence-culture.svg'],
      // ['Providence Gastronomy', 41.8067123, -71.4430743 , 3 , 'rhode-island-providence-gastronomy.svg'],
      // ['Newport Architecture', 41.4913679, -71.3180318 , 3 , 'rhode-island-newport-architecture.svg'],
      // ['Newport Beach', 41.4629216, -71.3680342 , 3 , 'rhode-island-newport-beach.svg'],
      // ['Newport Surf', 41.4512577, -71.3253626 , 3 , 'rhode-island-newport-surf.svg'],
      // ['Myrtle Beach', 33.7198685, -78.9488473 , 3 , 'south-carolina-myrtle-beach-beach.svg'],
      // ['Hilton Head Island Beach', 32.1836148, -80.8174358 , 3 , 'south-carolina-hilton-head-island-beach.svg'],
      // ['Charleston History', 32.8030546, -79.9846372 , 3 , 'south-carolina-charlston-history.svg'],
      // ['Charleston Culture', 32.8706869, -79.996236 , 3 , 'south-carolina-charlston-culture.svg'],
      // ['Charleston Gastronomy', 32.7792558, -80.0422381 , 3 , 'south-carolina-charlston-gastronomy.svg'],
      // ['Congaree National Park Nature', 33.7967479, -80.8031162 , 3 , 'south-carolina-congaree-national-park-nature.svg'],
      // ['Sioux Falls Nature', 43.5557883, -96.6236436 , 3 , 'south-dakota-sioux-falls-nature.svg'],
      // ['Sioux Falls Gastronomy', 43.5590382, -96.7411017 , 3 , 'south-dakota-sioux-falls-gastronomy.svg'],
      // ['Rapid City History', 44.0763403, -103.2381382 , 3 , 'south-dakota-rapid-city-history.svg'],
      // ['Rapid City Mountains', 43.7922906, -103.5846644 , 3 , 'south-dakota-rapid-city-mountains.svg'],
      // ['Rapid City Indians', 44.2006551, -103.4620463 , 3 , 'south-dakota-rapid-city-indians.svg'],
      // ['Rapid City Mount Rushmore ', 44.0758749, -103.4753781 , 3 , 'south-dakota-rapid-city-mount-rushmore.svg'],
      // ['Black hills Badland Nartional Parks', 43.6835523, -102.6622526 , 3 , 'south-dakota-black-hills-badland-nartional-parks.svg'],
      // ['Black hills Custer State Park', 43.8453383, -103.6273726 , 3 , 'south-dakota-black-hills-custer-state-park.svg'],
      // ['Black hills Indians', 43.9758504, -103.4278923 , 3 , 'south-dakota-black-hills-indians.svg'],
      // ['Black hills Roughlock Falls', 44.3381211, -103.9668514 , 3 , 'south-dakota-black-roughlock-falls.svg'],
      // ['Nashville Gastronomy', 36.1411755, -86.842801 , 3 , 'tennessee-nashville-gastronomy.svg'],
      // ['Nashville History', 36.1951904, -86.7540091 , 3 , 'tennessee-nashville-history.svg'],
      // ['Nashville Music', 36.1998132, -86.8788906 , 3 , 'tennessee-nashville-music.svg'],
      // ['Menphis Graceland', 35.0476912, -90.028238  , 3 , 'tennessee-menphis-graceland.svg'],
      // ['Menphis Music',  35.2367297, -89.9901663 , 3 , 'tennessee-menphis-music.svg'],
      // ['Menphis Rock And Roll ', 35.1633007, -90.164484 , 3 , 'tennessee-menphis-rock.svg'],
      // ['Menphis History',  35.2054044, -89.7791637 , 3 , 'tennessee-menphis-history.svg'],
      // ['Knoxville City', 35.9593409, -83.9867835 , 3 , 'tennessee-knoxville-city.svg'],
      // ['Chattanooga City', 35.0982754, -85.3087306 , 3 , 'tennessee-chattanooga-city.svg'],
      // ['Chattanooga Lookout Mountain', 34.9980237, -85.3622128 , 3 , 'tennessee-chattanooga-falls.svg'],
      // ['Townsend Great Smoky mountains National Parks',  35.5807622, -83.8114602 , 3 , 'tennessee-townsend-great-smoky-mountains-national-parks.svg'],
      // ['Servervielle Mountains',  35.6565773, -83.627631 , 3 , 'tennessee-servervielle-mountain.svg'],
      // ['Servervielle History', 35.9095577, -83.6358036 , 3 , 'tennessee-servervielle-history.svg'],
      // ['Austin City', 30.3076863, -97.8934849 , 3 , 'texas-austin-city.svg'],
      // ['Austin Formula 1',  30.1345808, -97.6380398 , 3 , 'texas-austin-f1.svg'],
      // ['Houston City', 29.8168824, -95.6814744 , 3 , 'texas-houston-city.svg'],
      // ['Houston Gastronomy', 29.701009, -95.350747 , 3 , 'texas-houston-gastronomy.svg'],
      // ['Houston Art', 29.9268815, -95.4864338 , 3 , 'texas-houston-art.svg'],
      // ['Houston Museums', 29.6825353, -95.5525119 , 3 , 'texas-houston-museum.svg'],
      // ['Houston Sports', 29.8229024, -95.5914103 , 3 , 'texas-houston-sports.svg'],
      // ['Fort Worth Shopping',  32.800735, -97.4294022 , 3 , 'texas-fort-worth-shopping.svg'],
      // ['Fort Worth Museums', 32.7265839, -97.547622 , 3 , 'texas-fort-worth-museum.svg'],
      // ['Fort Worth Casa de la moneda',  32.899825, -97.3479159 , 3 , 'texas-fort-worth-dollar.svg'],
      // ['Fort Worth Speedway', 33.0373212, -97.3521652 , 3 , 'texas-fort-worth-speedway.svg'],
      // ['Plano Gastronomy', 33.0469903, -96.8057508 , 3 , 'texas-plano-gastronomy.svg'],
      // ['Plano Shopping', 33.076855, -96.8233586 , 3 , 'texas-plano-shopping.svg'],
      // ['Plano City', 33.0543211, -96.7972661 , 3 , 'texas-plano-city.svg'],
      // ['Beaumont Gastronomy', 30.0762174, -94.135205 , 3 , 'texas-beaumont-gastronomy.svg'],
      // ['Beaumont Shopping', 30.0250304, -94.1750358 , 3 , 'texas-beaumont-shopping.svg'],
      // ['Beaumont Museums', 30.1267137, -94.1203284 , 3 , 'texas-beaumont-museum.svg'],
      // ['Frederisckbur Rock State park', 30.4950693, -98.8220059 , 3 , 'texas-frederisckburg-rock-state-park.svg'],
      // ['Frederisckbur Gastronomy',  30.2566865, -98.8614039 , 3 , 'texas-frederisckburg-gastronomy.svg'],
      // ['Frederisckbur Craft', 30.2960948, -98.8769735 , 3 , 'texas-frederisckburg-craft.svg'],
      // ['South Padre Island Beach', 26.1384201, -97.1722108 , 3 , 'texas-south-padre-island-beach.svg'],
      // ['Bandera History', 29.7233822, -99.0809017 , 3 , 'texas-bandera-history.svg'],
      // ['Bandera Cowboys', 29.6890889, -99.050818 , 3 , 'texas-bandera-cowboy.svg'],
      // ['San Antonio History', 29.4126886, -98.534409 , 3 , 'texas-san-antonio-history.svg'],
      // ['San Antonio Natural bridge Caverns',  29.6923229, -98.3449699 , 3 , 'texas-san-antonio-caverns.svg'],
      // ['San Antonio The Alamo Missio', 29.4259671, -98.4883306 , 3 , 'texas-san-antonio-the-alamo-mission.svg'],
      // ['San Antonio Gastronomy', 29.4374459, -98.4497579 , 3 , 'texas-san-antonio-the-alamo-gastronomy.svg'],
      // ['Dallas Culture', 32.7921978, -96.7879391 , 3 , 'texas-dallas-culture.svg'],
      // ['Dallas History', 32.8066491, -96.9518535 , 3 , 'texas-dallas-history.svg'],
      // ['Dallas Gastronomy', 32.5340787, -96.938974 , 3 , 'texas-dallas-gastronomy.svg'],
      // ['Dallas Cowboys', 32.8298174, -96.6605346 , 3 , 'texas-dallas-cowboy.svg'],
      // ['Dallas City', 32.7752258, -96.8032678 , 3 , 'texas-dallas-city.svg'],
      // ['Salt Lake City', 40.7590447, -111.8992489 , 3 , 'utah-salt-lake-city-city.svg'],
      // ['Salt Lake City Adventure', 40.7460567, -111.8083255 , 3 , 'utah-salt-lake-city-adventure.svg'],
      // ['Bryce Canyon National Park', 37.5735691, -112.3183965 , 3 , 'utah-bryce-canyon-national-park.svg'],
      // ['Vernal Fantasy Canyon', 40.0573611, -109.3954078 , 3 , 'utah-vernal-fantasy-canon.svg'],
      // ['Vernal Green Rivers', 38.9926012, -110.1748053 , 3 , 'utah-vernal-green-rivers.svg'],
      // ['Vernal Leisurely Stroll', 40.4543078, -109.5531512 , 3 , ''],
      // ['Canyonalnd National Parks', 38.2271598, -110.1807709 , 3 , 'utah-canyonalnd-national-parks.svg'],
      // ['Cedar City Breacks National monument', 37.6359586, -112.8472135 , 3 , 'utah-cedar-city-breacks-national-monument.svg'],
      // ['Park City Ski', 40.6482218, -111.5349809 , 3 , 'utah-park-city-ski.svg'],
      // ['Park City Mountains', 40.605816, -111.7605925 , 3 , 'utah-park-city-mountains.svg'],
      // ['St. Gerorge Zion National Park', 37.3222826, -113.1833179 , 3 , 'utah-st-george-zion-national-park.svg'],
      // ['Logan Fishing', 41.7553551, -111.9530247 , 3 , 'utah-logan-fishing.svg'],
      // ['Logan Mountains', 41.7712235, -111.7254618 , 3 , 'utah-logan-mountains.svg'],
      // ['Moab Dead horse point State Park', 38.474933, -109.7428086 , 3 , 'utah-moab-dead-horse-point-state-park.svg'],
      // ['Moab Arches National Park', 38.7320195, -109.7257243 , 3 , 'utah-arches-national-park.svg'],
      // ['Kanab History',  37.0303934, -112.5656138 , 3 , 'utah-kanab-history.svg'],
      // ['Kanab Desert', 36.9931615, -112.5864862 , 3 , 'utah-kanab-desert.sv'],
      // ['Kanab Mountains', 37.0593511, -112.5996433 , 3 , 'utah-kanab-mountains.svg'],
      // ['Kanab Balloons', 37.0553928, -112.5150906 , 3 , 'utah-kanab-balloons.svg'],
      // ['St. Thomas Beach', 18.3098881, -64.8981675 , 3 , 'us-virgin-island-st-thomas-beach.svg'],
      // ['St. Thomas History', 18.3385555, -64.8970516 , 3 , 'us-virgin-island-st-thomas-history.svg'],
      // ['Burlingtone Ski', 44.4161492, -72.8486468 , 3 , 'vermont-burlingtone-ski.svg'],
      // ['Burlingtone History', 44.4778826, -73.2175544  , 3 , 'vermont-burlingtone-history.svg'],
      // ['Burlingtone Architecture', 44.4522831, -73.2109551 , 3 , 'vermont-burlingtone-architecture.svg'],
      // ['Stowe Mount Mansfield', 44.5436771, -72.8230451  , 3 , 'vermont-stowe-mount-mansfield.svg'],
      // ['Stowe Ski', 44.5279536, -72.777469 , 3 , 'vermont-stowe-ski.svg'],
      // ['Richmond City', 37.5336938, -77.4391355 , 3 , 'virginia-richmond-city.svg'],
      // ['Richmond History', 37.4853967, -77.4977879 , 3 , 'virginia-richmond-history.svg'],
      // ['Shenandoah National Park', 38.2927558, -78.6795836 , 3 , 'virginia-shenandoah-national-park.svg'],
      // ['Arlington Pentagon',  38.8713196, -77.0584499, 3 , 'virginia-arlington-pentagon.svg'],
      // ['Arlington Cemetery', 38.8819781, -77.0923442 , 3 , 'virginia-arlington-tomb.svg'],
      // ['Arlington History', 38.8801926, -77.1086906 , 3 , 'virginia-arlington-history.svg'],
      // ['Virginia Beach', 36.8130332, -76.1149418 , 3 , 'virginia-virginia-beach-beach.svg'],
      // ['Alexandria Colonial', 38.8167926, -77.045686 , 3 , 'virginia-alexandria-colonial.svg'],
      // ['Alexandria History', 38.8062934, -77.0591026 , 3 , 'virginia-alexandria-history.svg'],
      // ['Alexandria Gastronomy', 38.825258, -77.1180406 , 3 , 'virginia-alexandria-gastronomy.svg'],
      // ['Olympia Nisqually National Wildlife Refuge', 47.072769, -122.7149175 , 3 , 'washington-olympia-nisqually-national-wildlife-refuge.svg'],
      // ['Olympia Moun Rainier', 46.8523066, -121.7690777 , 3 , 'washington-olympia-mount-rainier.svg'],
      // ['Olympia Tumwater Fall ', 47.0171399, -122.908441 , 3 , 'washington-olympia-tumwater-fall.svg'],
      // ['Olympia Lush', 47.2164853, -122.4733455 , 3 , 'washington-olympia-lush.svg'],
      // ['Olympia City', 47.0393281, -122.9288879 , 3 , 'washington-olympia-city.svg'],
      // ['Olympia Olympic National Park', 47.7854541, -123.9203694 , 3 , 'washington-olympia-olympic-national-park.svg'],
      // ['Seatlle City', 47.5971604, -122.3422794 , 3 , 'washington-seattle-city.svg'],
      // ['Seatlle Ski', 47.4946417, -121.6626036  , 3 , 'washington-seattle-ski.svg'],
      // ['Seatlle Mount Rainier National Park', 46.8600215, -121.8550053 , 3 , 'washington-seattle-mount-rainier-national-park.svg'],
      // ['Seatlle Cascading Snoqualmie Falls', 47.5391694, -121.8415879 , 3 , 'washington-seattle-cascading-snoqualmie-falls.svg'],
      // ['Long Beach Peninsula Beach', 46.3756897, -124.2233276 , 3 , 'washington-long-beach-beach.svg'],
      // ['Long Beach Peninsula Adventure', 46.5332881, -123.8733821 , 3 , 'washington-long-beach-adventure.svg'],
      // ['Long Beach Peninsula Willapa National Wildlife Refuge ', 46.4139457, -123.9354877  , 3 , 'washington-long-beach-willapa-national-wildlife-refuge.svg'],
      // ['Long Beach Peninsula Clark National Historic Park ', 46.1315073, -123.9035356 , 3 , 'washington-long-beach-clark-national-historic-park.svg'],
      // ['SeaTac History', 47.4428542, -122.3081916 , 3 , 'washington-seatac-history.svg'],
      // ['SeaTac City', 47.4613364, -122.2977099 , 3 , 'washington-seatac-city.svg'],
      // ['SeaTac Aviation Museum', 47.5200315, -122.3083198 , 3 , 'washington-seatac-aviation-museum.svg'],
      // ['San Juan Island National Wildlife Refuge', 48.5867524, -123.1529292 , 3 , 'washington-san-juan-island-national-wildlife-refuge.svg'],
      // ['Spokane Spokane Fall ', 47.6606851, -117.4353048 , 3 , 'washington-spokane-spokane-falls.svg'],
      // ['Spokane City',  47.6611286, -117.4322971, 3 , 'wyoming-cheyenne-city.svg'],
      // ['Cheyenne City',  41.1475272, -104.8024239 , 3 , 'wyoming-cheyenne-city.svg'],
      // ['Cheyenne History', 41.1819184, -104.7871216 , 3 , 'wyoming-cheyenne-history.svg'],
      // ['Cheyenne Yelowstone National Park', 44.584425, -111.0744583 , 3 , 'wyoming-yelowstone-national-park.svg'],
      // ['Laramie Vedauwoo National Park', 41.1568085, -105.3789728 , 3 , 'wyoming-laramie-vedauwoo-national-park.svg'],
      // ['Laramie Lake Marie', 41.334863, -106.3263052 , 3 , 'wyoming-laramie-lake-marie.svg'],
      // ['Laramie Sugarloaf Mountain', 41.3560802, -106.3137715 , 3 , 'wyoming-laramie-sugarloaf-mounatin.svg'],
      // ['Sheridan Mountains', 44.7743513, -107.3859468 , 3 , 'wyoming-sheridan-mountains.svg'],
      // ['Sheridan Adventure', 44.7930345, -106.9724449 , 3 , 'wyoming-sheridan-adventure.svg'],
      // ['Casper History', 42.8451219, -106.3366672 , 3 , 'wyoming-casper-history.svg'],
      // ['Casper Mountains', 42.7343168, -106.4925401 , 3 , 'wyoming-casper-mountains.svg'],
      // ['Casper Fishing',  42.8149931, -106.4024737 , 3 , 'wyoming-casper-fishing.svg'],
      // ['Grand Teton National Park', 43.7616986, -110.7851225 , 3 , 'wyoming-grand-teton-national-park.svg'],
      // ['Thermopolis Mountains', 43.6244959, -108.1841482 , 3 , 'wyoming-thermopolis-mountains.svg'],
      // ['Thermopolis Indians', 43.6653123, -108.2038836 , 3 , 'wyoming-thermopolis-indians.svg'],
      // ['Thermopolis Legend Petroglyph Site', 43.799606, -108.5992381 , 3 , 'wyoming-thermopolis-legend-petroglyphsite.svg'],
      // ['Pinedale Adventure', 42.8654991, -109.8794554 , 3 , 'wyoming-pinedale-adventure.svg'],
      // ['Pinedale Mountains', 42.8445046, -109.9179826 , 3 , 'wyoming-pinedale-mountains.sv'],
      // ['Pinedale Fishing', 42.9112382, -109.8314195 , 3 , 'wyoming-pinedale-fishing.svg'],
      // ['Gillete and Wright Devils Tower National Monument', 44.5904549, -104.7227216 , 3 , 'wyoming-gillette-devils-tower-national-monument.svg'],
      // ['Gillete and Wright Ski', 44.2720055, -105.5353858 , 3 , 'wyoming-gillette-ski.svg'],
      // ['Gillete and Wright Mountains', 44.3298132, -105.6018304 , 3 , 'wyoming-gillette-mountains.svg'],
      // ['Cody History', 44.5190065, -109.0809699 , 3 , 'wyoming-cody-history.sv'],
      // ['Cody Rafting', 44.5190015, -109.0809699 , 3 , 'wyoming-cody-rafting.svg'],
      // ['Cody Rodeo', 44.5201498, -109.0961421 , 3 , 'wyoming-cody-rodeo.svg'],
      // ['Bismark City',  46.8090546, -100.8370939 , 3 , 'north-dakota-bismark-city.svg'],
      // ['Bismark History', 46.8512904, -100.7602471 , 3 , 'north-dakota-bismark-history.svg'],
      // ['Bismark Indians', 46.8800397, -100.8229586 , 3 , ''],
      // ['Bismark Abrahan Lincoln National Park', 46.7660582, -100.8500234 , 3 , 'north-dakota-bismark-abraham-lincoln-national-park.svg'],
      // ['Fargo City', 46.8734979, -96.8926583 , 3 , 'north-dakota-fargo-city.svg'],

      // ['Madison City', 43.069583, -89.435541 , 3 , 'wisconsin-madison-city.svg'],
      // ['Madison Gastronomy', 43.0530942, -89.5367306 , 3 , 'wisconsin-madison-gastronomy.svg'],
      // ['Milwaukee City', 43.0378868, -87.9092844 , 3 , 'wisconsin-milwaukee-city.svg'],
      // ['Milwaukee Shopping', 43.0643378, -88.0600222 , 3 , 'wisconsin-milwaukee-shopping.svg'],
      // ['Milwaukee Gastronomy', 43.123163, -87.9513829 , 3 , 'wisconsin-milwaukee-gastronomy.svg'],
      // ['Kohler Golf', 43.7267074, -87.7773113 , 3 , 'wisconsin-kohler-golf.svg'],
      // ['Green Bay City', 44.522924, -88.060534  , 3 , 'wisconsin-green-bay-city.svg'],
      // ['Green Bay History',  44.5276263, -87.8882565 , 3 , 'wisconsin-green-bay-history.svg'],
      // ['Sturgeon Bay Adventure', 44.8261451, -87.3990308  , 3 , 'wisconsin-sturgeon-bay-adventure.svg'],
      // ['Sturgeon Bay Crystal-clear waters of cave Point County Park', 44.9307404, -87.1762614 , 3 , 'wisconsin-sturgeon-bay-cave-point-country-park.svg'],
      // ['Charleston City', 38.3434281, -81.7135832 , 3 , 'west-virginia-charleston-city.svg'],
      // ['Morgantown Mountains', 39.6716094, -79.807269 , 3 , 'west-virginia-morgantown-mountains.svg'],
      // ['Morgantown Adventure', 39.6939029, -79.9282969 , 3 , 'west-virginia-morgantown-adventure.svg'],
      // ['Morgantown Decker Creek ', 39.628414, -79.9696519 , 3 , 'west-virginia-morgantown-decker-creek.svg'],
      // ['Morgantown History', 39.5951739, -79.9646782 , 3 , 'west-virginia-morgantown-history.svg'],
      // ['Wheeling Historical bridge',  40.0702228, -80.7268417 , 3 , 'west-virginia-wheeling-historical-bridge.svg']

    ];

    const image = {
      url: '',
      /* size: new google.maps.Size(32, 32),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0)*/
    };
    for (let i = 0; i < this.beaches.length; i++) {
      const beach = this.beaches[i];
      image.url =  'assets/img/app/icons/' + beach[4];
      const marker = new google.maps.Marker({
        position: {lat: beach[1], lng: beach[2]},
        map: this.map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 3,
          fillColor: 'red',
          fillOpacity: 1,
          strokeOpacity: .3
        }, // image,
        title: beach[0],
        zIndex: beach[3]
      });
      this.iconMarkers.push(marker);
    }

    console.log('CONTENIDO DEL MAPA', this.map);

    let zoomLevel = 1;
    google.maps.event.addListener( this.map, 'zoom_changed', (function(map: google.maps.Map, iconMarkers, beaches ) {
      return function(evt) {

        let i: any, prevZoomLevel: any;
        prevZoomLevel = zoomLevel;
        map.getZoom() < 5 ? zoomLevel = 1 : zoomLevel = 2;

        if (prevZoomLevel !== zoomLevel) {
          for (i = 0; i < iconMarkers.length; i++) {
            const beach = beaches[i];
            image.url =  'assets/img/app/icons/' + beach[4];
            if (zoomLevel === 2) {
              iconMarkers[i].setIcon(image.url);
            } else {
              iconMarkers[i].setIcon({
                path: google.maps.SymbolPath.CIRCLE,
                scale: 3,
                fillColor: 'red',
                fillOpacity: 1,
                strokeOpacity: .3
              });
            }
          }
        }
      };
    })( this.map, this.iconMarkers, this.beaches ));


  }

  addLayout() {
    const swBound = new google.maps.LatLng(this.latswBound, this.lngswBound);
    const neBound = new google.maps.LatLng(this.latneBound, this.lngneBound);
    const bounds = new google.maps.LatLngBounds(swBound, neBound);
  }

  initPolyline() {
    this.poly = new google.maps.Polyline({
      strokeColor: '#1fc997',
      strokeOpacity: 0.7,
      strokeWeight: 3
    });
    this.poly.setMap(this.map);
  }

  searchAdress(data: Array<any>) {
    const geocoder = new google.maps.Geocoder();
    if (typeof data !== undefined && data[0] !== undefined) {
      if (this.markers.length > 0) {
        this.path.clear();
        this.deleteMarkers();
      }
      if (data[0].destination.length > 0) {
        this.poly.setMap(this.map);
        this.path = this.poly.getPath();
        data[0].destination.forEach((element) => {
          this.codeAddress(geocoder, element);
        });
      }
    }
  }

  codeAddress(geocoder: google.maps.Geocoder, element: any) {
    geocoder.geocode({ 'address': element.destination_info.cityName }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        this.path.push(results[0].geometry.location);
        const marker = new google.maps.Marker({
          map: this.map,
          position: results[0].geometry.location,
          label: String(element.destination_info.position),
          draggable: false,
          title: element.iata_code,
          zIndex: 20,
        });
        this.markers.push(marker);
      } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
        console.error('Geocode was not successful for the following reason: ' + status);
        setTimeout(() => {
          this.codeAddress(geocoder, element);
        }, 2000);
      } else {
      }
    });
  }

  getCity(cityName: any) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': cityName }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        console.log(results[0].geometry.location);
        this.city = results[0].geometry.location;
      }
    });

  }

  deleteMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
